import { Alert, ButtonCopy, Tooltip, Typography } from 'shared/ui'
import { makeTextFieldElement, TextFieldPlaceholder } from 'shared/ui/TextField'
import styles from './styles.module.scss'

export type IWebhookActionContentProps = {
  webhookUrl: string
  source: 'campaign' | 'workflow' | 'AI Agent'
  sourceName: string
}

export const WebhookActionContent = ({
  sourceName,
  webhookUrl,
  source,
}: IWebhookActionContentProps) => {
  return (
    <div className={styles.modalContent}>
      <Alert
        item={{
          type: 'infoLight',
          title: 'Webhook URL generated',
          desc: `Use this URL to enroll contacts into ${sourceName}. Find it anytime on the ${source} details page.`,
        }}
      />
      <TextFieldPlaceholder
        className={styles.linkContainer}
        size={'medium'}
        variant={'stroke'}
        placeholder={
          <Tooltip placement='top' label={webhookUrl} fullWidth>
            <Typography
              className={styles.linkText}
              tag='div'
              ariaLabel='WebhookUrl'
              variant='text-input-field'
              color='var(--content-primary-primary)'
            >
              {webhookUrl}
            </Typography>
          </Tooltip>
        }
        rightActions={[
          makeTextFieldElement({
            element: (
              <ButtonCopy value={webhookUrl || ''} buttonProps={{ size: 'small', tag: 'div' }} />
            ),
          }),
        ]}
      />
    </div>
  )
}
